export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/email_copy.14e66fd.svg";